<script>
  import { marked } from "marked";
  export let content = "";

  let markdownDiv;
  $: if (markdownDiv) {
    markdownDiv.innerHTML = marked(content);
  }
</script>

<article class="markdown" bind:this={markdownDiv}></article>

<style>
  article {
    max-width: 800px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    font-size: 1rem;
    line-height: 1.6;
  }
  
  p {
    padding: 0;
  }

  @media (max-width: 600px) {
    article {
      padding: 0.5rem;
      font-size: 0.9rem;
    }
  }
</style>

